var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g, _g2, _g3, _path24, _path25, _g4, _circle, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g5, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg13ZoomerangCallStation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M945.218 438.546H942.245V520.015H945.218V438.546Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M943.701 468.832H941.996L941.501 471.644H945.96L945.515 468.832H943.701Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M945.624 471.644H941.838V483.861H945.624V471.644Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M942.027 486.117H945.426C945.654 486.117 945.842 485.93 945.842 485.702C945.842 485.475 945.654 485.287 945.426 485.287H942.027C941.799 485.287 941.61 485.475 941.61 485.702C941.62 485.93 941.799 486.117 942.027 486.117Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M945.218 520.015C945.218 520.252 944.554 520.44 943.732 520.44C942.909 520.44 942.245 520.252 942.245 520.015C942.245 519.777 942.909 519.589 943.732 519.589C944.554 519.589 945.218 519.787 945.218 520.015Z",
    fill: "#4D4D4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M894 418C894 418 927.234 430.39 945.5 440C963.433 449.434 994.5 471.5 994.5 471.5",
    stroke: "#1B1B1B",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M899.856 421.15C900.131 420.516 900.867 420.225 901.5 420.5L931.497 432.853C932.13 433.127 932.421 433.863 932.147 434.497C931.872 435.13 931.136 435.421 930.503 435.147L900.506 422.794C899.873 422.519 899.582 421.783 899.856 421.15Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M953.935 445.346C954.296 444.758 955.066 444.574 955.654 444.935L983.808 462.87C984.396 463.231 984.581 464.001 984.219 464.589C983.858 465.177 983.088 465.361 982.5 465L954.346 447.065C953.758 446.704 953.574 445.934 953.935 445.346Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M950.794 447.707L938.8 441.936C935.419 440.309 931.662 443.33 932.524 446.982C932.886 448.512 933.921 449.798 935.339 450.478L947.996 456.548C950.501 457.749 953.451 456.172 953.844 453.422C954.182 451.056 952.948 448.743 950.794 447.707Z",
    fill: "url(#paint0_linear_1989_6597)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M949.83 448.484L937.808 442.496C935.433 441.313 932.643 443.041 932.643 445.694C932.643 447.654 933.765 449.441 935.531 450.292L947.585 456.102C949.905 457.22 952.598 455.529 952.598 452.953C952.598 451.059 951.526 449.328 949.83 448.484Z",
    fill: "url(#paint1_linear_1989_6597)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M941.031 445.274C939.905 445.661 939.533 447.55 940.2 449.499C940.867 451.449 942.32 452.715 943.446 452.331C944.573 451.945 944.944 450.056 944.278 448.106C943.611 446.157 942.157 444.891 941.031 445.274Z",
    fill: "url(#paint2_linear_1989_6597)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M943.445 452.331C943.445 452.331 943.48 452.32 943.544 452.297C943.606 452.27 943.701 452.229 943.806 452.151C943.911 452.075 944.028 451.967 944.14 451.824C944.252 451.681 944.35 451.5 944.43 451.292C944.59 450.874 944.672 450.352 944.65 449.794C944.631 449.237 944.516 448.649 944.328 448.089C944.23 447.81 944.113 447.536 943.982 447.276C943.85 447.017 943.702 446.77 943.537 446.543C943.375 446.317 943.197 446.112 943.013 445.938C942.829 445.761 942.637 445.613 942.447 445.498C942.258 445.38 942.067 445.301 941.891 445.254C941.714 445.208 941.555 445.195 941.426 445.199C941.297 445.201 941.195 445.229 941.129 445.246C941.063 445.266 941.03 445.28 941.03 445.28C941.03 445.28 941.064 445.272 941.131 445.252C941.2 445.239 941.299 445.219 941.427 445.223C941.555 445.225 941.71 445.243 941.879 445.297C942.049 445.348 942.229 445.434 942.412 445.554C942.782 445.788 943.143 446.158 943.456 446.605C943.613 446.827 943.759 447.071 943.885 447.326C944.014 447.585 944.126 447.852 944.218 448.127C944.409 448.679 944.526 449.256 944.547 449.801C944.572 450.344 944.512 450.862 944.365 451.273C944.292 451.477 944.202 451.66 944.099 451.804C943.998 451.949 943.887 452.062 943.788 452.138C943.688 452.217 943.598 452.265 943.535 452.295C943.477 452.316 943.445 452.331 943.445 452.331Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M941.028 449.216C941.459 450.476 942.381 451.311 943.125 451.137C943.099 451.147 943.075 451.16 943.047 451.167C942.293 451.426 941.317 450.576 940.871 449.269C940.425 447.964 940.675 446.694 941.429 446.435C941.455 446.425 941.483 446.419 941.508 446.412C940.817 446.731 940.597 447.956 941.028 449.216Z",
    fill: "#A6A6A6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M943.607 448.337C944.038 449.597 943.821 450.822 943.127 451.138C942.384 451.312 941.461 450.479 941.03 449.217C940.599 447.957 940.816 446.731 941.51 446.415C942.251 446.24 943.176 447.074 943.607 448.337Z",
    fill: "url(#paint3_linear_1989_6597)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M941.45 449.074C941.773 450.017 942.464 450.643 943.019 450.513C943 450.521 942.98 450.529 942.961 450.534C942.396 450.729 941.669 450.092 941.334 449.115C941 448.137 941.187 447.189 941.752 446.995C941.771 446.987 941.79 446.982 941.812 446.977C941.29 447.213 941.127 448.129 941.45 449.074Z",
    fill: "url(#paint4_linear_1989_6597)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M943.378 448.414C943.702 449.357 943.539 450.273 943.019 450.512C942.464 450.643 941.773 450.02 941.45 449.074C941.127 448.131 941.289 447.215 941.809 446.976C942.364 446.846 943.056 447.469 943.378 448.414Z",
    fill: "url(#paint5_linear_1989_6597)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M941.728 448.979C941.952 449.636 942.432 450.068 942.818 449.976C942.805 449.983 942.792 449.989 942.779 449.993C942.388 450.128 941.879 449.685 941.648 449.005C941.417 448.326 941.547 447.666 941.938 447.531C941.951 447.527 941.967 447.521 941.98 447.518C941.618 447.686 941.504 448.322 941.728 448.979Z",
    fill: "url(#paint6_linear_1989_6597)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M943.069 448.521C943.293 449.178 943.179 449.814 942.818 449.979C942.432 450.071 941.952 449.636 941.727 448.982C941.503 448.325 941.617 447.689 941.978 447.524C942.365 447.429 942.845 447.864 943.069 448.521Z",
    fill: "url(#paint7_linear_1989_6597)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M942.041 448.87C942.153 449.197 942.392 449.411 942.583 449.368C942.577 449.369 942.57 449.374 942.564 449.376C942.368 449.442 942.115 449.222 942.002 448.886C941.886 448.549 941.95 448.221 942.146 448.152C942.153 448.15 942.159 448.149 942.165 448.147C941.988 448.229 941.932 448.543 942.041 448.87Z",
    fill: "url(#paint8_linear_1989_6597)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M942.708 448.642C942.82 448.969 942.764 449.284 942.583 449.368C942.392 449.414 942.153 449.197 942.041 448.87C941.929 448.543 941.985 448.228 942.166 448.144C942.36 448.101 942.599 448.316 942.708 448.642Z",
    fill: "url(#paint9_linear_1989_6597)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M942.18 448.362C942.078 448.396 942.044 448.569 942.104 448.748C942.165 448.928 942.283 448.328 942.18 448.362Z",
    fill: "url(#paint10_linear_1989_6597)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M942.607 449.173C942.668 449.152 942.688 449.048 942.653 448.939C942.617 448.833 942.546 449.194 942.607 449.173Z",
    fill: "url(#paint11_linear_1989_6597)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M940.735 449.317C940.289 448.012 940.677 446.694 941.43 446.438C941.456 446.428 941.484 446.422 941.51 446.415C942.253 446.241 943.176 447.074 943.607 448.336C944.038 449.596 943.821 450.822 943.127 451.138C943.102 451.147 943.078 451.161 943.05 451.167C942.293 451.426 941.181 450.624 940.735 449.317Z",
    fill: "url(#paint12_linear_1989_6597)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 938.765,
    cy: 449.675,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 937.858,
    cy: 449.221,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936.951,
    cy: 448.767,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936.044,
    cy: 448.314,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938.765,
    cy: 448.767,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 937.858,
    cy: 448.314,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936.951,
    cy: 447.86,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936.044,
    cy: 447.407,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938.765,
    cy: 447.86,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 937.858,
    cy: 447.407,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936.951,
    cy: 446.953,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936.044,
    cy: 446.5,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938.765,
    cy: 446.953,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 937.858,
    cy: 446.5,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936.951,
    cy: 446.046,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936.044,
    cy: 445.592,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938.765,
    cy: 446.046,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 937.858,
    cy: 445.592,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936.951,
    cy: 445.139,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936.044,
    cy: 444.686,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938.765,
    cy: 445.139,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 937.858,
    cy: 444.686,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936.951,
    cy: 444.232,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936.044,
    cy: 443.779,
    r: 0.226762,
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 948.742,
    cy: 454.663,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 947.836,
    cy: 454.21,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.928,
    cy: 453.756,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.021,
    cy: 453.302,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948.742,
    cy: 453.756,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 947.836,
    cy: 453.302,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.928,
    cy: 452.849,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.021,
    cy: 452.395,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948.742,
    cy: 452.849,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 947.836,
    cy: 452.395,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.928,
    cy: 451.942,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.021,
    cy: 451.488,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948.742,
    cy: 451.942,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 947.836,
    cy: 451.488,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.928,
    cy: 451.035,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.021,
    cy: 450.581,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948.742,
    cy: 451.035,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 947.836,
    cy: 450.581,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.928,
    cy: 450.128,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.021,
    cy: 449.675,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948.742,
    cy: 450.128,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 947.836,
    cy: 449.675,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.928,
    cy: 449.221,
    r: 0.226762,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.021,
    cy: 448.767,
    r: 0.226762,
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1989_6597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.533 284.227L625.337 280.451L627.773 320.975L615.888 325.142L610.422 341.685L563.014 344.903L559.533 284.227Z",
    fill: "url(#paint13_linear_1989_6597)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M626.545 298.179L625.325 280.59L603.373 281.675L626.545 298.179Z",
    fill: "url(#paint14_linear_1989_6597)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M627.773 320.975L610.422 341.686L615.394 324.792L627.773 320.975Z",
    fill: "#7DC76D"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1989_6597)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 594.509,
    cy: 283.165,
    r: 2.56803,
    transform: "rotate(-9.54103 594.509 283.165)",
    fill: "#FFA800"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 594.509,
    cy: 283.165,
    r: 1.71202,
    transform: "rotate(-9.54103 594.509 283.165)",
    stroke: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M588.711 329.8L601.253 333.708L601.253 334.088C601.253 334.383 601.019 334.624 600.725 334.633L596.357 334.766C595.638 334.787 594.929 334.596 594.32 334.215L588.967 330.869C588.808 330.77 588.711 330.595 588.711 330.407L588.711 329.8Z",
    fill: "#1A1A1A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M593.374 329.437C594.011 329.437 594.637 329.604 595.189 329.922L600.941 333.236C601.425 333.514 601.227 334.254 600.669 334.254L596.428 334.254C595.779 334.254 595.142 334.08 594.583 333.751L588.981 330.452C588.502 330.17 588.702 329.437 589.258 329.437L593.374 329.437Z",
    fill: "#333333"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M595.569 298.911L594.377 298.911L594.377 331.564L595.569 331.564L595.569 298.911Z",
    fill: "#4D4D4D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M594.961 311.049L594.278 311.049L594.08 312.176L595.867 312.176L595.688 311.049L594.961 311.049Z",
    fill: "#4D4D4D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M595.732 312.176L594.215 312.176L594.215 317.073L595.732 317.073L595.732 312.176Z",
    fill: "#333333"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M594.29 317.978L595.653 317.978C595.744 317.978 595.82 317.902 595.82 317.811C595.82 317.72 595.744 317.644 595.653 317.644L594.29 317.644C594.199 317.644 594.124 317.72 594.124 317.811C594.128 317.902 594.199 317.978 594.29 317.978Z",
    fill: "#333333"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M595.569 331.564C595.569 331.659 595.303 331.735 594.973 331.735C594.644 331.735 594.377 331.659 594.377 331.564C594.377 331.469 594.644 331.393 594.973 331.393C595.303 331.393 595.569 331.473 595.569 331.564Z",
    fill: "#4D4D4D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M575.496 290.376C575.638 290.051 576.017 289.903 576.341 290.045L593.399 297.52C594.764 298.118 596.065 298.671 597.282 299.532L613.057 309.054C613.347 309.259 613.415 309.66 613.211 309.95C613.006 310.239 612.605 310.308 612.316 310.103L596.54 300.581C595.394 299.77 594.169 299.26 592.883 298.696L575.826 291.222C575.501 291.079 575.353 290.701 575.496 290.376Z",
    fill: "#333333"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.027 301.532C599.096 301.436 599.229 301.414 599.325 301.482L610.456 308.311C610.552 308.38 610.575 308.513 610.506 308.61C610.438 308.706 610.304 308.729 610.208 308.66L599.077 301.831C598.981 301.762 598.958 301.629 599.027 301.532Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.815 291.66C577.862 291.551 577.989 291.502 578.097 291.55L590.726 297.115C590.834 297.163 590.883 297.289 590.835 297.397C590.788 297.506 590.661 297.555 590.553 297.507L577.924 291.942C577.816 291.894 577.767 291.768 577.815 291.66Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M597.803 302.7L592.996 300.387C591.641 299.735 590.135 300.945 590.481 302.409C590.626 303.022 591.04 303.537 591.609 303.81L596.682 306.243C597.686 306.724 598.868 306.092 599.026 304.99C599.161 304.042 598.667 303.115 597.803 302.7Z",
    fill: "url(#paint15_linear_1989_6597)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M597.52 303.061L592.368 300.496C591.523 300.075 590.529 300.69 590.529 301.635L590.529 302.036C590.529 302.734 590.929 303.37 591.557 303.673L596.702 306.153C597.547 306.56 598.527 305.944 598.527 305.007L598.527 304.688C598.527 303.999 598.137 303.369 597.52 303.061Z",
    fill: "url(#paint16_linear_1989_6597)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M593.892 301.607C593.44 301.762 593.291 302.519 593.558 303.301C593.825 304.082 594.408 304.589 594.859 304.436C595.311 304.281 595.46 303.524 595.193 302.742C594.925 301.961 594.343 301.454 593.892 301.607Z",
    fill: "url(#paint17_linear_1989_6597)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M594.858 304.436C594.858 304.436 594.872 304.431 594.898 304.422C594.923 304.411 594.961 304.395 595.003 304.363C595.045 304.333 595.092 304.29 595.137 304.233C595.182 304.175 595.221 304.103 595.253 304.019C595.317 303.852 595.35 303.642 595.341 303.419C595.334 303.196 595.288 302.96 595.212 302.735C595.173 302.623 595.126 302.514 595.074 302.41C595.021 302.306 594.961 302.207 594.895 302.116C594.83 302.025 594.759 301.943 594.685 301.873C594.612 301.802 594.535 301.743 594.459 301.697C594.383 301.65 594.306 301.618 594.236 301.599C594.165 301.581 594.101 301.575 594.049 301.577C593.998 301.578 593.957 301.589 593.931 301.596C593.904 301.604 593.891 301.61 593.891 301.61C593.891 301.61 593.905 301.606 593.931 301.598C593.959 301.593 593.999 301.585 594.05 301.587C594.101 301.587 594.163 301.595 594.231 301.616C594.299 301.637 594.371 301.671 594.445 301.719C594.593 301.813 594.738 301.961 594.863 302.141C594.926 302.23 594.984 302.327 595.035 302.43C595.087 302.533 595.131 302.64 595.168 302.751C595.245 302.972 595.292 303.203 595.3 303.422C595.31 303.639 595.286 303.847 595.227 304.012C595.198 304.093 595.162 304.167 595.12 304.225C595.08 304.283 595.035 304.328 594.996 304.358C594.956 304.39 594.92 304.409 594.895 304.421C594.871 304.43 594.858 304.436 594.858 304.436Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M593.889 303.187C594.061 303.692 594.431 304.026 594.729 303.957C594.718 303.961 594.709 303.966 594.698 303.969C594.395 304.072 594.004 303.732 593.826 303.208C593.647 302.685 593.747 302.176 594.049 302.072C594.06 302.068 594.071 302.065 594.081 302.063C593.804 302.191 593.716 302.682 593.889 303.187Z",
    fill: "#A6A6A6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M594.922 302.834C595.095 303.339 595.008 303.831 594.73 303.957C594.432 304.027 594.062 303.693 593.89 303.187C593.717 302.682 593.804 302.191 594.082 302.064C594.379 301.994 594.75 302.328 594.922 302.834Z",
    fill: "url(#paint18_linear_1989_6597)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M594.058 303.13C594.188 303.507 594.465 303.758 594.687 303.706C594.679 303.709 594.671 303.712 594.664 303.714C594.437 303.792 594.146 303.537 594.012 303.146C593.878 302.754 593.953 302.375 594.179 302.297C594.187 302.294 594.194 302.291 594.203 302.29C593.994 302.384 593.929 302.751 594.058 303.13Z",
    fill: "url(#paint19_linear_1989_6597)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M594.831 302.865C594.961 303.243 594.896 303.61 594.687 303.706C594.465 303.758 594.188 303.508 594.059 303.129C593.929 302.752 593.994 302.385 594.202 302.289C594.425 302.237 594.702 302.486 594.831 302.865Z",
    fill: "url(#paint20_linear_1989_6597)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M594.169 303.091C594.259 303.354 594.452 303.527 594.606 303.49C594.601 303.493 594.596 303.495 594.591 303.497C594.434 303.551 594.23 303.373 594.137 303.101C594.045 302.829 594.097 302.565 594.253 302.511C594.259 302.509 594.265 302.507 594.27 302.506C594.125 302.573 594.08 302.828 594.169 303.091Z",
    fill: "url(#paint21_linear_1989_6597)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M594.707 302.908C594.797 303.171 594.752 303.426 594.607 303.492C594.452 303.529 594.26 303.355 594.17 303.093C594.08 302.829 594.125 302.575 594.27 302.509C594.425 302.471 594.617 302.645 594.707 302.908Z",
    fill: "url(#paint22_linear_1989_6597)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M594.295 303.048C594.34 303.18 594.436 303.266 594.513 303.248C594.51 303.249 594.507 303.251 594.505 303.252C594.426 303.278 594.325 303.19 594.279 303.055C594.233 302.92 594.259 302.788 594.337 302.76C594.34 302.76 594.342 302.759 594.345 302.758C594.274 302.791 594.251 302.917 594.295 303.048Z",
    fill: "url(#paint23_linear_1989_6597)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M594.562 302.957C594.607 303.088 594.585 303.214 594.512 303.248C594.435 303.267 594.34 303.18 594.295 303.048C594.25 302.917 594.272 302.791 594.345 302.757C594.423 302.74 594.518 302.826 594.562 302.957Z",
    fill: "url(#paint24_linear_1989_6597)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M594.351 302.845C594.31 302.859 594.297 302.928 594.321 303C594.345 303.072 594.392 302.832 594.351 302.845Z",
    fill: "url(#paint25_linear_1989_6597)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M594.521 303.17C594.546 303.161 594.554 303.12 594.54 303.076C594.525 303.034 594.497 303.178 594.521 303.17Z",
    fill: "url(#paint26_linear_1989_6597)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M593.772 303.227C593.593 302.704 593.748 302.176 594.051 302.073C594.061 302.069 594.072 302.067 594.082 302.064C594.38 301.994 594.75 302.328 594.923 302.834C595.096 303.339 595.009 303.83 594.731 303.957C594.72 303.961 594.711 303.966 594.7 303.969C594.396 304.072 593.951 303.751 593.772 303.227Z",
    fill: "url(#paint27_linear_1989_6597)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.073 303.488C593.073 303.539 593.032 303.579 592.982 303.579C592.932 303.579 592.891 303.539 592.891 303.488C592.891 303.438 592.932 303.397 592.982 303.397C593.032 303.397 593.073 303.438 593.073 303.488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.71 303.306C592.71 303.356 592.669 303.397 592.619 303.397C592.569 303.397 592.528 303.356 592.528 303.306C592.528 303.256 592.569 303.215 592.619 303.215C592.669 303.215 592.71 303.256 592.71 303.306Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.346 303.125C592.346 303.175 592.306 303.215 592.255 303.215C592.205 303.215 592.165 303.175 592.165 303.125C592.165 303.074 592.205 303.034 592.255 303.034C592.306 303.034 592.346 303.074 592.346 303.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.983 302.943C591.983 302.993 591.942 303.034 591.892 303.034C591.841 303.034 591.801 302.993 591.801 302.943C591.801 302.893 591.841 302.852 591.892 302.852C591.942 302.852 591.983 302.893 591.983 302.943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.073 303.125C593.073 303.175 593.032 303.215 592.982 303.215C592.932 303.215 592.891 303.175 592.891 303.125C592.891 303.074 592.932 303.034 592.982 303.034C593.032 303.034 593.073 303.074 593.073 303.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.71 302.943C592.71 302.993 592.669 303.034 592.619 303.034C592.569 303.034 592.528 302.993 592.528 302.943C592.528 302.893 592.569 302.852 592.619 302.852C592.669 302.852 592.71 302.893 592.71 302.943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.346 302.761C592.346 302.811 592.306 302.852 592.255 302.852C592.205 302.852 592.165 302.811 592.165 302.761C592.165 302.711 592.205 302.67 592.255 302.67C592.306 302.67 592.346 302.711 592.346 302.761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.983 302.58C591.983 302.63 591.942 302.671 591.892 302.671C591.841 302.671 591.801 302.63 591.801 302.58C591.801 302.529 591.841 302.489 591.892 302.489C591.942 302.489 591.983 302.529 591.983 302.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.073 302.761C593.073 302.811 593.032 302.852 592.982 302.852C592.932 302.852 592.891 302.811 592.891 302.761C592.891 302.711 592.932 302.67 592.982 302.67C593.032 302.67 593.073 302.711 593.073 302.761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.71 302.58C592.71 302.63 592.669 302.671 592.619 302.671C592.569 302.671 592.528 302.63 592.528 302.58C592.528 302.529 592.569 302.489 592.619 302.489C592.669 302.489 592.71 302.529 592.71 302.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.346 302.398C592.346 302.448 592.306 302.488 592.255 302.488C592.205 302.488 592.165 302.448 592.165 302.398C592.165 302.347 592.205 302.307 592.255 302.307C592.306 302.307 592.346 302.347 592.346 302.398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.983 302.216C591.983 302.266 591.942 302.307 591.892 302.307C591.841 302.307 591.801 302.266 591.801 302.216C591.801 302.166 591.841 302.125 591.892 302.125C591.942 302.125 591.983 302.166 591.983 302.216Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.073 302.398C593.073 302.448 593.032 302.488 592.982 302.488C592.932 302.488 592.891 302.448 592.891 302.398C592.891 302.347 592.932 302.307 592.982 302.307C593.032 302.307 593.073 302.347 593.073 302.398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.71 302.216C592.71 302.266 592.669 302.307 592.619 302.307C592.569 302.307 592.528 302.266 592.528 302.216C592.528 302.166 592.569 302.125 592.619 302.125C592.669 302.125 592.71 302.166 592.71 302.216Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.346 302.034C592.346 302.084 592.306 302.125 592.255 302.125C592.205 302.125 592.165 302.084 592.165 302.034C592.165 301.984 592.205 301.943 592.255 301.943C592.306 301.943 592.346 301.984 592.346 302.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.983 301.852C591.983 301.902 591.942 301.943 591.892 301.943C591.841 301.943 591.801 301.902 591.801 301.852C591.801 301.802 591.841 301.761 591.892 301.761C591.942 301.761 591.983 301.802 591.983 301.852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.073 302.034C593.073 302.084 593.032 302.125 592.982 302.125C592.932 302.125 592.891 302.084 592.891 302.034C592.891 301.984 592.932 301.943 592.982 301.943C593.032 301.943 593.073 301.984 593.073 302.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.71 301.852C592.71 301.902 592.669 301.943 592.619 301.943C592.569 301.943 592.528 301.902 592.528 301.852C592.528 301.802 592.569 301.761 592.619 301.761C592.669 301.761 592.71 301.802 592.71 301.852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.346 301.67C592.346 301.721 592.306 301.761 592.255 301.761C592.205 301.761 592.165 301.721 592.165 301.67C592.165 301.62 592.205 301.58 592.255 301.58C592.306 301.58 592.346 301.62 592.346 301.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.983 301.489C591.983 301.539 591.942 301.58 591.892 301.58C591.841 301.58 591.801 301.539 591.801 301.489C591.801 301.439 591.841 301.398 591.892 301.398C591.942 301.398 591.983 301.439 591.983 301.489Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.073 301.67C593.073 301.721 593.032 301.761 592.982 301.761C592.932 301.761 592.891 301.721 592.891 301.67C592.891 301.62 592.932 301.58 592.982 301.58C593.032 301.58 593.073 301.62 593.073 301.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.71 301.489C592.71 301.539 592.669 301.58 592.619 301.58C592.569 301.58 592.528 301.539 592.528 301.489C592.528 301.439 592.569 301.398 592.619 301.398C592.669 301.398 592.71 301.439 592.71 301.489Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.346 301.307C592.346 301.357 592.306 301.398 592.255 301.398C592.205 301.398 592.165 301.357 592.165 301.307C592.165 301.257 592.205 301.216 592.255 301.216C592.306 301.216 592.346 301.257 592.346 301.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.983 301.125C591.983 301.175 591.942 301.216 591.892 301.216C591.841 301.216 591.801 301.175 591.801 301.125C591.801 301.075 591.841 301.034 591.892 301.034C591.942 301.034 591.983 301.075 591.983 301.125Z",
    fill: "black"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.072 305.488C597.072 305.538 597.031 305.579 596.981 305.579C596.931 305.579 596.89 305.538 596.89 305.488C596.89 305.438 596.931 305.397 596.981 305.397C597.031 305.397 597.072 305.438 597.072 305.488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.709 305.306C596.709 305.356 596.668 305.397 596.618 305.397C596.568 305.397 596.527 305.356 596.527 305.306C596.527 305.256 596.568 305.215 596.618 305.215C596.668 305.215 596.709 305.256 596.709 305.306Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.345 305.125C596.345 305.175 596.305 305.215 596.254 305.215C596.204 305.215 596.164 305.175 596.164 305.125C596.164 305.074 596.204 305.034 596.254 305.034C596.305 305.034 596.345 305.074 596.345 305.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.982 304.942C595.982 304.993 595.941 305.033 595.891 305.033C595.84 305.033 595.8 304.993 595.8 304.942C595.8 304.892 595.84 304.852 595.891 304.852C595.941 304.852 595.982 304.892 595.982 304.942Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.072 305.125C597.072 305.175 597.031 305.215 596.981 305.215C596.931 305.215 596.89 305.175 596.89 305.125C596.89 305.074 596.931 305.034 596.981 305.034C597.031 305.034 597.072 305.074 597.072 305.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.709 304.942C596.709 304.993 596.668 305.033 596.618 305.033C596.568 305.033 596.527 304.993 596.527 304.942C596.527 304.892 596.568 304.852 596.618 304.852C596.668 304.852 596.709 304.892 596.709 304.942Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.345 304.761C596.345 304.811 596.305 304.852 596.254 304.852C596.204 304.852 596.164 304.811 596.164 304.761C596.164 304.711 596.204 304.67 596.254 304.67C596.305 304.67 596.345 304.711 596.345 304.761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.982 304.579C595.982 304.629 595.941 304.67 595.891 304.67C595.84 304.67 595.8 304.629 595.8 304.579C595.8 304.529 595.84 304.488 595.891 304.488C595.941 304.488 595.982 304.529 595.982 304.579Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.072 304.761C597.072 304.811 597.031 304.852 596.981 304.852C596.931 304.852 596.89 304.811 596.89 304.761C596.89 304.711 596.931 304.67 596.981 304.67C597.031 304.67 597.072 304.711 597.072 304.761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.709 304.579C596.709 304.629 596.668 304.67 596.618 304.67C596.568 304.67 596.527 304.629 596.527 304.579C596.527 304.529 596.568 304.488 596.618 304.488C596.668 304.488 596.709 304.529 596.709 304.579Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.345 304.397C596.345 304.447 596.305 304.488 596.254 304.488C596.204 304.488 596.164 304.447 596.164 304.397C596.164 304.347 596.204 304.306 596.254 304.306C596.305 304.306 596.345 304.347 596.345 304.397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.982 304.215C595.982 304.266 595.941 304.306 595.891 304.306C595.84 304.306 595.8 304.266 595.8 304.215C595.8 304.165 595.84 304.125 595.891 304.125C595.941 304.125 595.982 304.165 595.982 304.215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.072 304.397C597.072 304.447 597.031 304.488 596.981 304.488C596.931 304.488 596.89 304.447 596.89 304.397C596.89 304.347 596.931 304.306 596.981 304.306C597.031 304.306 597.072 304.347 597.072 304.397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.709 304.215C596.709 304.266 596.668 304.306 596.618 304.306C596.568 304.306 596.527 304.266 596.527 304.215C596.527 304.165 596.568 304.125 596.618 304.125C596.668 304.125 596.709 304.165 596.709 304.215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.345 304.034C596.345 304.084 596.305 304.125 596.254 304.125C596.204 304.125 596.164 304.084 596.164 304.034C596.164 303.984 596.204 303.943 596.254 303.943C596.305 303.943 596.345 303.984 596.345 304.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.982 303.852C595.982 303.902 595.941 303.943 595.891 303.943C595.84 303.943 595.8 303.902 595.8 303.852C595.8 303.801 595.84 303.761 595.891 303.761C595.941 303.761 595.982 303.801 595.982 303.852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.072 304.034C597.072 304.084 597.031 304.125 596.981 304.125C596.931 304.125 596.89 304.084 596.89 304.034C596.89 303.984 596.931 303.943 596.981 303.943C597.031 303.943 597.072 303.984 597.072 304.034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.709 303.852C596.709 303.902 596.668 303.943 596.618 303.943C596.568 303.943 596.527 303.902 596.527 303.852C596.527 303.801 596.568 303.761 596.618 303.761C596.668 303.761 596.709 303.801 596.709 303.852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.345 303.67C596.345 303.72 596.305 303.761 596.254 303.761C596.204 303.761 596.164 303.72 596.164 303.67C596.164 303.62 596.204 303.579 596.254 303.579C596.305 303.579 596.345 303.62 596.345 303.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.982 303.488C595.982 303.539 595.941 303.579 595.891 303.579C595.84 303.579 595.8 303.539 595.8 303.488C595.8 303.438 595.84 303.397 595.891 303.397C595.941 303.397 595.982 303.438 595.982 303.488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.072 303.67C597.072 303.72 597.031 303.761 596.981 303.761C596.931 303.761 596.89 303.72 596.89 303.67C596.89 303.62 596.931 303.579 596.981 303.579C597.031 303.579 597.072 303.62 597.072 303.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.709 303.488C596.709 303.539 596.668 303.579 596.618 303.579C596.568 303.579 596.527 303.539 596.527 303.488C596.527 303.438 596.568 303.397 596.618 303.397C596.668 303.397 596.709 303.438 596.709 303.488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.345 303.307C596.345 303.357 596.305 303.398 596.254 303.398C596.204 303.398 596.164 303.357 596.164 303.307C596.164 303.257 596.204 303.216 596.254 303.216C596.305 303.216 596.345 303.257 596.345 303.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.982 303.125C595.982 303.175 595.941 303.215 595.891 303.215C595.84 303.215 595.8 303.175 595.8 303.125C595.8 303.074 595.84 303.034 595.891 303.034C595.941 303.034 595.982 303.074 595.982 303.125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1989_6597",
    x: 548.533,
    y: 275.451,
    width: 90.2407,
    height: 86.4526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.218507 0 0 0 0 0.221719 0 0 0 0 0.258333 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1989_6597"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1989_6597",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1989_6597",
    x: 588.941,
    y: 278.597,
    width: 11.1367,
    height: 11.1367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.35195 0 0 0 0 0.625 0 0 0 0 0.291667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1989_6597"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1989_6597",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1989_6597",
    x1: 933.414,
    y1: 443.28,
    x2: 953.119,
    y2: 454.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44484A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1989_6597",
    x1: 932.643,
    y1: 443.77,
    x2: 952.56,
    y2: 455.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292C2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1989_6597",
    x1: 943.446,
    y1: 452.331,
    x2: 941.032,
    y2: 445.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1989_6597",
    x1: 941.509,
    y1: 446.415,
    x2: 943.125,
    y2: 451.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30333D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1989_6597",
    x1: 941.268,
    y1: 447.158,
    x2: 942.479,
    y2: 450.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30333D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1989_6597",
    x1: 941.809,
    y1: 446.976,
    x2: 943.019,
    y2: 450.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30333D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1989_6597",
    x1: 941.601,
    y1: 447.648,
    x2: 942.443,
    y2: 450.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30333D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1989_6597",
    x1: 941.978,
    y1: 447.521,
    x2: 942.818,
    y2: 449.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30333D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1989_6597",
    x1: 941.979,
    y1: 448.208,
    x2: 942.398,
    y2: 449.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30333D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1989_6597",
    x1: 942.167,
    y1: 448.145,
    x2: 942.584,
    y2: 449.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16171C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1989_6597",
    x1: 942.183,
    y1: 448.576,
    x2: 942.044,
    y2: 448.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1989_6597",
    x1: 942.685,
    y1: 449.059,
    x2: 942.602,
    y2: 449.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2288,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7393,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9093,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1989_6597",
    x1: 941.361,
    y1: 446.461,
    x2: 942.979,
    y2: 451.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1989_6597",
    x1: 592.49,
    y1: 282.335,
    x2: 595.972,
    y2: 343.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEF9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91DE80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1989_6597",
    x1: 623.073,
    y1: 280.1,
    x2: 614.362,
    y2: 290.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1E892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2FAB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1989_6597",
    x1: 590.838,
    y1: 300.925,
    x2: 598.735,
    y2: 305.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44484A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1989_6597",
    x1: 590.529,
    y1: 301.122,
    x2: 598.512,
    y2: 305.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292C2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1989_6597",
    x1: 594.859,
    y1: 304.436,
    x2: 593.892,
    y2: 301.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1989_6597",
    x1: 594.082,
    y1: 302.064,
    x2: 594.73,
    y2: 303.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30333D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1989_6597",
    x1: 593.985,
    y1: 302.362,
    x2: 594.47,
    y2: 303.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30333D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1989_6597",
    x1: 594.203,
    y1: 302.289,
    x2: 594.687,
    y2: 303.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30333D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1989_6597",
    x1: 594.118,
    y1: 302.558,
    x2: 594.456,
    y2: 303.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30333D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1989_6597",
    x1: 594.27,
    y1: 302.508,
    x2: 594.606,
    y2: 303.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30333D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1989_6597",
    x1: 594.27,
    y1: 302.783,
    x2: 594.438,
    y2: 303.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30333D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1989_6597",
    x1: 594.345,
    y1: 302.758,
    x2: 594.513,
    y2: 303.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16171C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1989_6597",
    x1: 594.352,
    y1: 302.931,
    x2: 594.297,
    y2: 302.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1989_6597",
    x1: 594.553,
    y1: 303.124,
    x2: 594.519,
    y2: 303.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2288,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7393,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9093,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1989_6597",
    x1: 594.023,
    y1: 302.083,
    x2: 594.671,
    y2: 303.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101114"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg13ZoomerangCallStation);
export default __webpack_public_path__ + "static/media/13ZoomerangCallStation.462c876c0049ed0b4d845aece031f85b.svg";
export { ForwardRef as ReactComponent };